"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorage = void 0;
const StorageKeyReturnDefaults_1 = require("../types/storage/StorageKeyReturnDefaults");
class LocalStorage {
    static async isSupported() {
        return Promise.resolve(typeof window !== 'undefined' && !!window.localStorage);
    }
    async get(key) {
        const value = localStorage.getItem(key);
        if (!value) {
            if (typeof StorageKeyReturnDefaults_1.defaultValues[key] === 'object') {
                return JSON.parse(JSON.stringify(StorageKeyReturnDefaults_1.defaultValues[key]));
            }
            else {
                return StorageKeyReturnDefaults_1.defaultValues[key];
            }
        }
        else {
            try {
                return JSON.parse(value);
            }
            catch (jsonParseError) {
                return value; // TODO: Validate storage
            }
        }
    }
    async set(key, value) {
        if (typeof value === 'string') {
            return localStorage.setItem(key, value);
        }
        else {
            return localStorage.setItem(key, JSON.stringify(value));
        }
    }
    async delete(key) {
        return Promise.resolve(localStorage.removeItem(key));
    }
}
exports.LocalStorage = LocalStorage;
//# sourceMappingURL=LocalStorage.js.map